import { aiChatFeedbackFormUrl } from '@/constants/urls';
import { Flex, Link, Text } from '@electricjs/arc';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const FeedbackTextContainer = styled(Flex)`
  justify-content: center;
`;

export const FeedbackText = () => {
  const { t } = useTranslation('ai-chat');

  return (
    <FeedbackTextContainer>
      <Text variant="legal" intent="disabled">
        {t('aguiBetaDisclaimerPrefix')}{' '}
        <Link href={aiChatFeedbackFormUrl} target="_blank" variant="legal">
          {t('shareFeedback')}
        </Link>{' '}
        {t('aguiBetaDisclaimerSuffix')}
      </Text>
    </FeedbackTextContainer>
  );
};
